import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tomo-ii',
  templateUrl: './tomo-ii.component.html',
  styleUrls: ['./tomo-ii.component.css']
})
export class TomoIIComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
